<template>
    <VJoyScreenLoader v-if="loadingProjectInformation" />
    <VJoyPanel v-else-if="projectInformation">
        <template #panel-title>
            {{ `[${t('projectclient.expenses.validation.summary.title', {nbExpenses: numberExpenses})}] ${projectInformation.contract.subject}` }}
        </template>

        <template #panel-body>
            <div class="project-details">
                <hr />
                <div class="project-details__avatar-section">
                    <VJoyAvatar :photo-url="projectInformation.freelancer.pictureUrl" />
                    <div class="freelancer-info">
                        <p>{{ projectInformation.freelancer.fullName }}</p>
                        <span>{{ projectInformation.freelancer.headline }}</span>
                    </div>
                </div>
                <hr />
                <PriceDetails :project-id="projectInformation.projectId" :currency="projectInformation.contract.currency" />
            </div>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {useProjectInformationStore} from '@common/stores';
    import {useTranslation} from '#imports';
    import {VJoyAvatar, VJoyPanel, VJoyScreenLoader} from '@maltjoy/core-vue';
    import PriceDetails from './PriceDetails.vue';

    const {t} = useTranslation();

    defineProps<{numberExpenses: number}>();

    // projectInformation store
    const {projectInformation, loadingProjectInformation} = useProjectInformationStore();
</script>

<style lang="scss">
    .project-details {
        hr {
            height: 1px;
            background-color: var(--joy-color-neutral-30);
            border: none;
            margin-bottom: var(--joy-core-spacing-4);
        }

        &__avatar-section {
            display: flex;
            align-items: center;
            margin-bottom: var(--joy-core-spacing-4);

            .freelancer-info {
                margin-left: var(--joy-core-spacing-2);

                & > p {
                    margin-bottom: var(--joy-core-spacing-0);
                    font-size: var(--joy-font-size-primary-400);
                    font-weight: var(--joy-font-weight-bold);
                }
            }
        }
    }
</style>
